import { Container, styled } from '@mui/material';

export const StyledContainer = styled(Container)(() => ({
  width: '100% !important',
  maxWidth: '1600px !important',
}));
